// extracted by mini-css-extract-plugin
export default {"menu":"header_styles_menu__xy26S","main":"header_styles_main__XlX9b","headTittle":"header_styles_headTittle__aQFck","active":"header_styles_active__hF64t"};